"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SingleItem_1 = __importDefault(require("./SingleItem"));
const lodash_1 = __importDefault(require("lodash"));
const Pagination_1 = __importDefault(require("./Pagination"));
class Content {
    constructor($data) {
        this.$items = lodash_1.default.get($data, 'data.articles', {});
        this.$pagination = {
            meta: lodash_1.default.get($data, 'meta', {}),
            links: lodash_1.default.get($data, 'links', {}),
        };
    }
    render() {
        return `
        <div class="row mb-3 mx-0 px-res-0">
            ${this.initItems()}
        </div>
        ${new Pagination_1.default(this.$pagination).render()}
        `;
    }
    initItems() {
        let renderItems = '';
        if (lodash_1.default.isEmpty(this.$items)) {
            return `<div class="col-xl-12 col-md-12 d-flex justify-content-center align-items-center">
                        <div class="alert alert-custom alert-light-warning shadow text-center fade show mb-0 p-4" role="alert">
                            <div class="alert-icon">
                                <i class="fad fa-xmark-circle icon-2x"></i>
                            </div>
                            <div class="alert-text">
                                <h5 class="font-weight-bolder">نتیجه‌ای یافت نشد!</h5>
                                <p>از عبارت‌های متداول‌تر استفاده کنید و یا املای عبارت وارد‌شده را بررسی کنید.</p>
                            </div>
                        </div>
                    </div>`;
        }
        this.$items.forEach((product) => {
            renderItems = renderItems.concat(new SingleItem_1.default(product).render());
        });
        return renderItems;
    }
}
exports.default = Content;
